module.exports = __webpack_public_path__ + "static/img/T7399_test.c849bf44.png";